import type { VoucherBannerVariant } from '../../VoucherBanner.types'
import VoucherStepIcon from './components/VoucherStepIcon'
import { BenefitText, Item, List, TermsLink } from './VoucherBenefits.styles'

interface VoucherBenefitsProps {
  amount: number | null
  providerName: string
  termsUrl: string
  onTermsClick: () => void
  variant?: VoucherBannerVariant
}

const VoucherBenefits = ({
  amount,
  providerName,
  termsUrl,
  onTermsClick,
  variant = 'smava'
}: VoucherBenefitsProps) => (
  <List>
    <Item>
      <VoucherStepIcon step={1} variant={variant} />
      <BenefitText>
        {'Gutschein aktivieren ('}
        <TermsLink
          href={termsUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Bedingungen (öffnet in neuem Fenster)"
          onClick={onTermsClick}
        >
          Bedingungen
        </TermsLink>
        {' gelten)'}
      </BenefitText>
    </Item>
    <Item>
      <VoucherStepIcon step={2} variant={variant} />
      <BenefitText>Kreditvertrag über {providerName} abschließen</BenefitText>
    </Item>
    <Item>
      <VoucherStepIcon step={3} variant={variant} />
      <BenefitText>
        {amount ? `${amount} €` : ''} Gutschein erhalten
      </BenefitText>
    </Item>
  </List>
)

export default VoucherBenefits
